$('.card-body-close').on('click', function() {
    $(this).closest('div.configurator-card').addClass('d-none');
});